import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css';
import './assets/css/swap.css';
import './assets/css/bootstrap.min.css';
import './assets/css/swiper.min.css';
import './assets/css/style.css';
import './assets/css/media_query.css';

import HomeSlider from './pages/HomeSlider';
import OurBlog from "./pages/OurBlog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

import Footer from "./component/Footer";
import Header from "./component/Header";
import ScrollTopPage from './component/ScrollTopPage';
import Preloader from './component/Preloader';
import ScrollToTopButton from "./component/ScrollToTopButton";
import SmoothScroll from './hooks/SmoothScroll';
import ContactForm from "./component/ContactForm";

function App() {
  return (
    <>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollTopPage />
        <Header />
        <Preloader />
        <Routes>
          <Route path="/" element={<HomeSlider />} />
          <Route path="/OurBlog" element={<OurBlog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ContactForm />
        <Footer />
        <ScrollToTopButton />
      </BrowserRouter>
    </>
  );
}

export default App;
